import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import safeSum from '../../../../../../utils/safeSum';

const useTopMessagesOptions = () => {
  const messages = useSelector((state) => state.resonance.messages);
  const sortedMessages = useMemo(
    () =>
      [...messages]?.sort(
        (a, b) => safeSum(b.accurateR1Total, b.accurateR2Total) - safeSum(a.accurateR1Total, a.accurateR2Total),
      ),
    [messages],
  );

  const formattedOptions = useMemo(() => {
    const top10Messages = sortedMessages?.slice(0, 10) || [];

    return top10Messages.map((message) => ({
      label: message.message,
      value: message.id,
      calculations: {
        r1: message.r1Total,
        r2: message.r2Total,
        total: safeSum(message.accurateR1Total, message.accurateR2Total),
      },
    }));
  }, [sortedMessages]);

  return formattedOptions;
};

export default useTopMessagesOptions;
